import { cn } from "../../../lib/cn";

/**
 * Marks staging sample content (`isSample`), so nobody mistakes a seeded post
 * for a real parent's. Neutral on purpose: it labels, it doesn't decorate.
 */
export function SampleChip({ className }: { className?: string }) {
  return (
    <span
      title="Sample content for this preview"
      className={cn(
        "inline-flex items-center rounded-full border border-neutral-200 bg-neutral-100 px-2 py-0.5 text-[11px] font-semibold uppercase tracking-wide text-neutral-700",
        className,
      )}
    >
      Sample
    </span>
  );
}
